#!/usr/bin/env node

import { Agent, setGlobalDispatcher } from 'undici'

import { checkNodeVersion } from '@/helpers/node-version'
import { getProgram } from '@/program'
import './imports'

import { checkUpgrade } from '@/helpers/upgrade'

// Check Node.js version before anything else
checkNodeVersion()

// Enable http2
setGlobalDispatcher(
  new Agent({
    allowH2: true,
  }),
)

const program = getProgram()

/** display help if no argument has been provided */
if (process.argv.length === 2) {
  program.help()
}

// Only check for updates if not running the upgrade command
if (process.argv[2] !== 'upgrade') {
  await checkUpgrade()
}

program.parse()
